// extracted by mini-css-extract-plugin
export default {"container":"container-bXVJL","primaryMessage":"primaryMessage-FcgKW","secondaryMessage":"secondaryMessage-akPBf"};